import React from 'react'
import { Typography } from '@mui/material'
import { SetStudentAssetsDialog, SecondaryCta } from 'components'
import numeral from 'numeral'
import { assetsFormatter } from 'formatters'
import { useGetCryptoTopQuery } from 'features'

/**
 * Display the student's assets and button to define or change them in a grid cell
 * @param {object} params - The param object from the Mui DataGrid column definition
 * @returns {ReactComponentElement} - component with ammount format and button to toggle set assets dialog
 */
function GridSetStudentAssetsAction({ value, row }) {
  let amount = numeral(value).value() / 100
  const { data: cryptoLimit, isLoading: cryptoLimitsLoading } =
    useGetCryptoTopQuery()

  const limitRow =
    cryptoLimit &&
    cryptoLimit.rows.filter((limitRow) => limitRow.cycle === row.schoolcycle)
  const limit = limitRow && limitRow[0] ? limitRow[0].amount : 0

  return (
    <div className="flex flex-row-reverse flex-nowrap justify-between items-center gap-4 w-full">
      {!cryptoLimitsLoading && (
        <>
          <SetStudentAssetsDialog
            togglerComponent={SecondaryCta}
            togglerProps={{
              size: 'grid',
              className: 'min-w-[20em]',
              disabled: row.state === 's' || limit === 0 || row.sge,
            }}
            rowData={row}
            limit={limit}
          >
            Definir activos
          </SetStudentAssetsDialog>
          {amount > 0 && (
            <Typography variant="body1" className="flex-grow">
              {assetsFormatter(amount * 100)}
            </Typography>
          )}
        </>
      )}
    </div>
  )
}

export const MemoizedGridSetStudentAssetsAction = React.memo(
  GridSetStudentAssetsAction
)
